/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { StyleguideSectionProps } from "@/src/styleguide/components/StyleguideSection/StyleguideSection.tsx";
import { StyleguideInnerProps } from "@/src/styleguide/components/Styleguide/Styleguide.tsx";
import { ListItem, ListSubheader } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { styleguideStyle } from "@/src/styleguide/components/Styleguide/styleguideStyle.ts";
import { Link } from "react-router";
import { Fragment } from "react";
import Typography from "@mui/material/Typography";

export type StyleguideLinkRendererProps = { section: StyleguideInnerProps["sections"][0]; level?: StyleguideSectionProps["level"] };

export default function StyleguideLinkRenderer({ section, level = 1 }: StyleguideLinkRendererProps) {
  return (
    <Fragment>
      <ListSubheader
        component={level === 1 ? ListSubheader : ListItem}
        sx={mergeSx(
          level === 1 && {
            padding: "0.75rem 0",
          },
          level !== 1 && {
            padding: "0.3rem 0",
          },
          styleguideStyle.linkListSubheader,
        )}
      >
        <Link to={"#" + section.id}>
          <Typography variant={level === 1 ? "button" : "body3"}>{section.title}</Typography>
        </Link>
      </ListSubheader>
      {section.subSections &&
        section.subSections.map((subSection) => <StyleguideLinkRenderer section={subSection} level={2} key={subSection.id} />)}
    </Fragment>
  );
}
